import { reactComponent } from './utils'
import { render } from '@verndale/core'
import ResponsiveTable from './components/responsive-table'

export function global() {
  const $responsiveTable = document.querySelectorAll('.responsive-table')
  instantiateModule($responsiveTable, ResponsiveTable)
}

const instantiateModule = (elements, Module) => render(elements, (el) => new Module(el))

const modules = [
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'field',
    loader: () => import('./components/field')
  },
  {
    name: 'header',
    loader: () => import('./modules/header')
  },
  {
    name: 'ask-the-expert-row',
    loader: () => import('./modules/ask-the-expert-row')
  },
  {
    name: 'coveo-search',
    loader: () => import('./modules/coveo-search')
  },
  {
    name: 'search-form',
    loader: () => import('./components/search-form')
  },
  {
    name: 'masthead',
    loader: () => import('./modules/masthead')
  },
  {
    name: 'call-to-action-row',
    loader: () => import('./modules/call-to-action-row')
  },
  {
    name: 'jump-links',
    loader: () => import('./modules/jump-links')
  },
  {
    name: 'jump-links-timeline',
    loader: () => import('./modules/jump-links-timeline')
  },
  {
    name: 'jump-links-gas-properties',
    loader: () => import('./modules/jump-links-gas-properties')
  },
  {
    name: 'testimonial-carousel',
    loader: () => import('./modules/testimonial-carousel')
  },
  {
    name: 'content-row',
    loader: () => import('./modules/content-row')
  },
  {
    name: 'supply-mode',
    loader: () => import('./react-components/supply-mode'),
    render: reactComponent
  },
  {
    name: 'search-results',
    loader: () => import('./react-components/search-results'),
    render: reactComponent
  },
  {
    name: 'news-listing',
    loader: () => import('./react-components/news-listing'),
    render: reactComponent
  },
  {
    name: 'news-row',
    loader: () => import('./modules/news-row')
  },
  {
    name: 'slider-news-row',
    loader: () => import('./modules/slider-news-row')
  },
  {
    name: 'modal',
    loader: () => import('./modules/modal')
  },
  {
    name: 'accordion-item',
    loader: () => import('./modules/accordion-item')
  },
  {
    name: 'accordion-row',
    loader: () => import('./modules/accordion-row')
  },
  {
    name: 'faq-listing',
    loader: () => import('./modules/faq-listing')
  },
  {
    name: 'filtered-listing',
    loader: () => import('./react-components/filtered-listing'),
    render: reactComponent
  },
  {
    name: 'filtered-listing-new',
    loader: () => import('./react-components/filtered-listing-new'),
    render: reactComponent
  },
  {
    name: 'section-navigation',
    loader: () => import('./modules/section-navigation')
  },
  {
    name: 'applications-listing',
    loader: () => import('./modules/applications-listing')
  },
  {
    name: 'featured-cards-row',
    loader: () => import('./modules/featured-cards-row')
  },
  {
    name: 'dry-ice-calculator',
    loader: () => import('./modules/dry-ice-calculator')
  },
  {
    name: 'coveo-search-results',
    loader: () => import('./react-components/coveo-search-results'),
    render: reactComponent
  },
  {
    name: 'search-box',
    loader: () => import('./react-components/search-box'),
    render: reactComponent
  }
]

export default modules
